import { FC } from "react";
import { Box, Flex, Title, Button } from "@mantine/core";
import { useGo } from "@refinedev/core";

import styles from "@scss/footer/footer.module.scss";
import Logo from "@images/logo/cwiggo-logo-console.svg";

import { CustomSplitTitle } from "../custom";
import { Text } from "@mantine/core";
import { SocialLinks } from "./social-links";

import ArrowIcon from "@images/icons/arrow.png";

export const CustomFooter: FC = () => {
  const go = useGo();

  const handleLogoClick = () => {
    go({
      to: "/",
      type: "push",
    });
  };

  return (
    <Box className={styles.footerWrapper}>
      <Box className={styles.footerContainer}>

        <Flex justify="space-between" mb={0} direction={"column"} mt={'50px'} className={styles.mainFooterContentWrapper}>
          <Flex direction={"column"} className={styles.mainFooterContentInner}>

            <Flex direction={"column"} className={styles.footerTextContent}>
              <Title
                order={2} 
                style={{
                  position: 'absolute',
                  width: '1px',
                  height: '1px',
                  padding: 0,
                  margin: '-1px',
                  overflow: 'hidden',
                  clip: 'rect(0, 0, 0, 0)',
                  whiteSpace: 'nowrap',
                  border: 0
                }}
              >
                Ready for results that stick?
              </Title>

              <Flex justify="space-between" align="center" mb="xl" className={styles.splitTitleWrapper}>
                <CustomSplitTitle
                  order={2}
                  partA="Ready for<br/> results that "
                  partB="stick?"
                  partAStyle={{ color: '#FFF' }}
                  partBStyle={{ color: '#A4F9AD' }}
                  aria-hidden="true"
                />
              </Flex>

              <Text size="xl" mt={0} variant="white" className={styles.footerSupportText}>
                At ACBRANDS, we act as your commercial engine, delivering fast-paced results without the headcount headache.
              </Text>
            </Flex>
            {/* <Button
              variant={"secondary"}
              onClick={() => go({ to: "/contact-us", type: "push" })}
              tt="uppercase"
              fw={600}
              fz={14}
              mt={'16px'}
              mb={'55px'}
            >
              <Flex justify="space-between" mb={0} direction={"row"} style={{width: "100%"}}>
                <Flex mr={10} display="flex" align="end">
                  <Text size="lg" fw={600} component="span" ta={"left"}>Get in <br/>touch</Text>
                  <Text size="lg" fw={300} component="span" fs="italic" ml={"3px"} mb={"1px"}> Now</Text>
                </Flex>
                <Flex justify="center" align="center">
                  <img
                    src={ArrowIcon}
                    alt="Arrow Icon"
                    style={{
                      width: '34px',
                      height: '22px',
                    }}
                  />
                </Flex>
              </Flex>
            </Button> */}
            <Button
              variant={"secondary"}
              onClick={() => go({ to: "/faq", type: "push" })}
              tt="uppercase"
              fw={600}
              fz={14}
              mt={'16px'}
              mb={'55px'}
            >
              <Flex justify="space-between" mb={0} direction={"row"} style={{width: "100%"}}>
                <Flex mr={10} display="flex" align="end">
                  <Text size="lg" fw={600} component="span" ta={"left"}>FAQs</Text>
                  <Text size="lg" fw={300} component="span" fs="italic" ml={"3px"} mb={"1px"}></Text>
                </Flex>
                <Flex justify="center" align="center">
                  <img
                    src={ArrowIcon}
                    alt="Arrow Icon"
                    style={{
                      width: '34px',
                      height: '22px',
                    }}
                  />
                </Flex>
              </Flex>
            </Button>
          </Flex>

          <Flex justify="space-between" mb={"25px"} direction={"row"} style={{width: "100%"}} className={styles.logoSocialWrapper}>
            <Flex mr={10} display="flex" align="end">
              <img
                className={"footerLogo"}
                src={Logo}
                alt={"ACBRANDS Logo"}
                onClick={handleLogoClick}
                style={{ cursor: "pointer", height: '22px', width: '156px' }}
              />
            </Flex>
            <SocialLinks />
          </Flex>
        </Flex>
      </Box>
      <hr className={styles.footerHr} />
      <Flex 
        justify="center" 
        mb={0} 
        direction={"column"} 
        className={styles.copyrightWrapper}
        style={{width: "100%", height: "75px"}}
      >
        <Flex display="flex" align="start">
          <Text size="md" fw={400} component="span" ta={"left"} mt={"5px"} variant="white">©{new Date().getFullYear()} ACBRANDS</Text>
        </Flex>
      </Flex>
    </Box>
  );
};
